module.exports = __webpack_public_path__ + "static/media/Landbuilding1.f9831d22.svg";